import React from 'react';
import { useNavigate } from 'react-router-dom';

const SupportPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-dark text-white">
            <div className="max-w-2xl mx-auto px-4 py-8">
                <button
                    onClick={() => navigate(-1)}
                    className="text-gray-400 hover:text-gold mb-6 flex items-center gap-1"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Back
                </button>

                <h1 className="text-2xl font-bold text-gold mb-6">Contact Support</h1>

                <div className="space-y-6">
                    <div className="bg-gray-800 rounded-lg p-6">
                        <h2 className="text-lg font-semibold mb-2">Email Support</h2>
                        <p className="text-gray-400 mb-1">Reach out to our support team via email:</p>
                        <a href="mailto:support@vivara.com" className="text-gold hover:underline text-lg">support@vivara.com</a>
                    </div>

                    <div className="bg-gray-800 rounded-lg p-6">
                        <h2 className="text-lg font-semibold mb-2">In-App Support</h2>
                        <p className="text-gray-400">
                            Logged in users can submit a support ticket directly from the app.
                            Go to your Profile → Help & Support.
                        </p>
                    </div>

                    <div className="bg-gray-800 rounded-lg p-6">
                        <h2 className="text-lg font-semibold mb-2">Account Deletion</h2>
                        <p className="text-gray-400 mb-1">
                            To request account deletion, send an email from your registered email address to:
                        </p>
                        <a href="mailto:support@drvivara.org" className="text-gold hover:underline">support@drvivara.org</a>
                        <p className="text-gray-500 text-sm mt-1">
                            Subject: "Account & Data Deletion Request"
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportPage;
